import { AxiosInstance } from 'axios';

const fileService = (client: AxiosInstance) => {
  const getFileUploadUrl = () => `${client.defaults.baseURL}files`;

  return { getFileUploadUrl };
};

export default fileService;
